"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _EXYNE2GEcjs = require('./EXYNE2GE.cjs');




var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/hovercard/hovercard-heading.tsx
var TagName = "h1";
var useHovercardHeading = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useHovercardHeading2(props) {
    props = _EXYNE2GEcjs.usePopoverHeading.call(void 0, props);
    return props;
  }
);
var HovercardHeading = _PTOCUU2Dcjs.forwardRef.call(void 0, function HovercardHeading2(props) {
  const htmlProps = useHovercardHeading(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});




exports.useHovercardHeading = useHovercardHeading; exports.HovercardHeading = HovercardHeading;
